import styled from 'styled-components';

interface WrapperProps {
  imageOverlay: boolean;
  iconOnly: boolean;
}

export const Wrapper = styled.button<WrapperProps>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${({ iconOnly }) => (iconOnly ? '0.75rem' : '0.75rem 1.5rem')};
  background-color: transparent;
  border-radius: var(--t-button-border-radius);
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.54);
  pointer-events: none;
  z-index: 1;
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  z-index: 2;
`;

export const Text = styled.span`
  font: normal normal 700 1rem/1.375rem var(--t-base-font-family);
  color: var(--t-button-secondary-hover-fg-color);
  white-space: nowrap;
`;
